import { getSellers } from '../services';
export const fetchSellers = () => getSellers().then(response => formatResponse(response?.data));
const formatResponse = (response) => response?.data.map(seller => ({
    label: seller?.fullname + ' - ' + seller?.enrolment,
    value: seller?.id,
}));
